module.exports = __webpack_public_path__ + "img/1501087655.3aabac16.jpg";